import styled from 'styled-components';
import { shade } from 'polished';

export const Container = styled.button`
  background: #fff;
  height: 46px;
  border-radius: 5px;
  border: 1px solid;
  border-color: #0180c7;
  padding: 0 16px;
  color: #312e38;
  width: 100%;
  font-weight: 500;
  // margin-top: 16px;
  transition: background-color 0.2s;

  &:hover {
    background: ${shade(0.2, '#ff9000')};
  }
`;
